<template>

  <div class="ui grid segment container" v-if="inCart"> 
    <div class="ui form sixteen wide column">
      <div class="field">
        <h3 class="ui header">{{ lang.say('TABLE_HEADING_COMMENTS') }}</h3>
        <textarea name="comments" v-html="content"></textarea>
      </div>
    </div>
  </div>

</template>


<script>
    import lang from '../lang';

    export default {
        data() {
            return {
                lang
            }
        },
        props: ['in-cart', 'content']
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Comment.vue?3b194e94